module.exports = __webpack_public_path__ + "media/images/flags/ae-2c530f6449f3e5abd04b2df6be77ee0a.svg";